export default { 
  Auth: require('./auth').default,
  Dashboard: require('./Dashboard').default,
  User: require('./user').default,
  Errors: require('./errors').default,
}
